import { useState } from 'react';
import { useFetch } from './useFetch';
import { API_CONFIG } from '../config/api';

interface CreateSocialData {
  type: string;
  url: string;
}

interface CreateState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

export const useSocialCreate = () => {
  const [createState, setCreateState] = useState<CreateState>({
    isLoading: false,
    error: null,
    success: false,
  });

  const { fetchWithAuth } = useFetch();

  const createSocial = async (data: CreateSocialData): Promise<boolean> => {
    setCreateState({
      isLoading: true,
      error: null,
      success: false,
    });

    try {
      const response = await fetchWithAuth(`${API_CONFIG.BASE_URL}/socials`, {
        method: 'POST',
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro ao criar social: ${response.status} - ${errorText}`);
      }

      await response.json();

      setCreateState(prev => ({ ...prev, isLoading: false, success: true }));
      return true;
    } catch (error) {
      setCreateState(prev => ({
        ...prev,
        error: error instanceof Error ? error.message : 'Erro desconhecido',
        isLoading: false,
      }));
      return false;
    }
  };

  const resetCreateState = () => {
    setCreateState({
      isLoading: false,
      error: null,
      success: false,
    });
  };

  return {
    createSocial,
    createState,
    resetCreateState,
  };
};
